"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _core = require("@material-ui/core");

var _Tabs = _interopRequireDefault(require("vf-comps/build/components/molecules/tabs/Tabs"));

var _BoxContainer = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxContainer/BoxContainer"));

var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));

var _searchActions = require("../actions/searchActions");

var _appConstants = require("../constants/appConstants");

var _tabContent = _interopRequireDefault(require("../components/tabContent"));

var _Header = _interopRequireDefault(require("../components/Header"));

var _BoxStyled = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxStyled/BoxStyled"));

var _styles = require("@material-ui/core/styles");

var _searchValidation = require("../utils/searchValidation");

var _defaultAddressMapping = _interopRequireDefault(require("../utils/defaultAddressMapping"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)({
  tabs: {
    justifyContent: 'center'
  }
});

var App = function App(_ref) {
  var _ref$config = _ref.config,
      searchCategories = _ref$config.category,
      searchTypes = _ref$config.data,
      validChars = _ref$config.validChars,
      templateId = _ref$config.templateId,
      apiPath = _ref$config.apiPath,
      instanceId = _ref.instanceId;
  var t = (0, _useTranslation.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var theme = (0, _core.useTheme)();
  var isSmall = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));
  var isDeskTop = (0, _core.useMediaQuery)(theme.breakpoints.up('md'));
  var classes = useStyles();
  var tabs = searchCategories.map(function (category) {
    return {
      tab: t(category.name),
      testId: category.name
    };
  });

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state[_appConstants.pkgName];
  }),
      customerDetails = _useSelector.customerDetails,
      type = _useSelector.type,
      apiError = _useSelector.error;

  var initialSelectedItem = searchTypes.find(function (el) {
    return el.name === type;
  }) || searchTypes[0];

  var _useState = (0, _react.useState)(initialSelectedItem),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItem = _useState2[0],
      setSelectedItem = _useState2[1];

  var _useState3 = (0, _react.useState)(searchCategories.find(function (cat) {
    return cat.id === initialSelectedItem.categoryId;
  })),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCategory = _useState4[0],
      setSelectedCategory = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      textVal = _useState8[0],
      setTextVal = _useState8[1];

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      searchValue = _useState10[0],
      setSearchValue = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      prevSearchValue = _useState12[0],
      setPrevSearchValue = _useState12[1];

  var selectedTabIndex = tabs.findIndex(function (el) {
    return el.tab === t(selectedCategory.name);
  }) || 0;

  var _useState13 = (0, _react.useState)(selectedTabIndex),
      _useState14 = _slicedToArray(_useState13, 2),
      activeTab = _useState14[0],
      setActiveTab = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      submitValue = _useState16[0],
      setSubmitValue = _useState16[1];

  var regexOfPersonalID = searchTypes.reduce(function (arr, item) {
    var _searchCategories$fin;

    var personalIdCategoryId = (_searchCategories$fin = searchCategories.find(function (cat) {
      return cat.name === 'personalId';
    })) === null || _searchCategories$fin === void 0 ? void 0 : _searchCategories$fin.id;
    if (item.categoryId === personalIdCategoryId) arr.push(item.regex);
    return arr;
  }, []);
  /**
   * on component reload
   */

  (0, _react.useEffect)(function () {
    setError(false);
    dispatch((0, _searchActions.setInstanceId)(instanceId));
    dispatch((0, _searchActions.resetCustomerSearchError)());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    var queryParam = selectedItem.queryParam,
        name = selectedItem.name;

    if (submitValue) {
      var queryParamWithId = setIdWithinQuery(queryParam, searchValue.toUpperCase().toString().trim());
      dispatch((0, _searchActions.setSearchQueryParams)(queryParamWithId));
      dispatch((0, _searchActions.getCustomerSearchData)({
        name: name,
        value: searchValue,
        queryParam: queryParamWithId,
        apiPath: apiPath
      }));
      setSubmitValue(false);
    }
  }, [submitValue]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (customerDetails.length) getDefaultAddressPath();
  }, [selectedItem, customerDetails]);
  /** iterate over searchItems within same category
   * check max length validity
   * check regex validity
   * add extra validator for nif/nie
   */

  var checkSearchValidity = function checkSearchValidity() {
    var validSearchItem = true,
        valid = true,
        isInvalid = true,
        extraValid = true;
    var id = selectedCategory.id,
        maxLength = selectedCategory.maxLength;
    var filteredSearchItems = searchTypes.filter(function (searchType) {
      return searchType.categoryId === id;
    });

    if (maxLength < searchValue.length) {
      valid = false;
      isInvalid = false;
    }

    filteredSearchItems.forEach(function (searchItem) {
      if (isInvalid) {
        var regex = searchItem.regex,
            extraValidationFunction = searchItem.extraValidationFunction;
        valid = searchValue.match(regex);

        if (valid && extraValidationFunction) {
          extraValid = _searchValidation.validationFuncs[extraValidationFunction](searchValue, setError, validChars, selectedItem, setSearchValue, setTextVal);
        }

        if (valid && extraValid) {
          isInvalid = false;
          validSearchItem = searchItem;
          return;
        }
      }
    });
    return {
      valid: valid && extraValid,
      validSearchItem: validSearchItem
    };
  };
  /**
   * dispatch an action of search criteria has a default address path
   */


  var getDefaultAddressPath = function getDefaultAddressPath() {
    var name = selectedItem.name;
    if (!_defaultAddressMapping.default[name]) return;

    var billingAddress = _defaultAddressMapping.default[name](customerDetails, searchValue);

    dispatch((0, _searchActions.defaultBillingAddressChanged)(billingAddress));
  };
  /**
   * if the no search value return
   * set selected item and value if new value entered and valid
   */


  var submits = function submits() {
    if (!searchValue.trim().length) return;

    var _checkSearchValidity = checkSearchValidity(),
        valid = _checkSearchValidity.valid,
        validSearchItem = _checkSearchValidity.validSearchItem;

    if (valid && prevSearchValue !== searchValue) {
      setSubmitValue(true);
      setSelectedItem(validSearchItem);
      setPrevSearchValue(searchValue);
    }

    if (!valid) {
      setPrevSearchValue(searchValue);
    }

    setError(!valid);
    document.activeElement.blur();
  };
  /** handle TextField change
   * reset error
   * reset prev search details
   * set test field text and error
   */


  var handleInputChange = function handleInputChange(value) {
    if (selectedCategory.name.toLowerCase().includes('billing') && value.replace(/ /g, '') === textVal) return;
    dispatch((0, _searchActions.resetCustomerSearch)());
    setTextVal(value);
    setSearchValue(value);
    setError(false);
  };
  /* reset PrevSearchValue*/


  var resetPrevSearchValue = function resetPrevSearchValue() {
    setPrevSearchValue('');
  };
  /**
   * replace inserted value with template id in query params
   */


  var setIdWithinQuery = function setIdWithinQuery(query, id) {
    return query.replace(templateId, id);
  };
  /**
   * submit on enter
   * @param {*} event
   */


  var onkeypress = function onkeypress(event) {
    if (event.which === 13) {
      submits();
    }

    if (event.target.value.length === selectedItem.maxLength && event.target.selectionStart === event.target.selectionEnd) {
      event.preventDefault();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Header.default, {
    t: t
  }), /*#__PURE__*/_react.default.createElement(_BoxStyled.default, {
    className: {
      width: isDeskTop ? 'calc(100vw - 360px)' : 'calc(100vw - 90px)',
      margin: 'auto',
      padding: '40px',
      paddingTop: '0px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    centered: isDeskTop,
    tabs: tabs,
    className: !isSmall ? classes.tabs : '',
    type: "tabs",
    minWidth: isSmall ? '140px' : '220px',
    value: activeTab >= 0 && activeTab,
    action: function action(index) {
      setSelectedCategory(searchCategories[index]);
      setActiveTab(index);
      setTextVal('');
      setPrevSearchValue('');
      setSearchValue('');
      setError(false);
      dispatch((0, _searchActions.resetCustomerSearch)());
    },
    onChange: function noRefCheck() {}
  })), /*#__PURE__*/_react.default.createElement(_BoxContainer.default, null, /*#__PURE__*/_react.default.createElement(_tabContent.default, {
    hasApiError: apiError,
    handleInputChange: handleInputChange,
    resetPrevSearchValue: resetPrevSearchValue,
    submits: submits,
    selectedCategory: selectedCategory,
    textVal: textVal,
    error: error,
    onkeypress: onkeypress,
    regexOfPersonalID: regexOfPersonalID
  })));
};

var _default = App;
exports.default = _default;